










































































































import { Component, Watch } from 'vue-property-decorator';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import FiltrosBusqueda from '@/pantallas/Camaras/Alertas/FiltrosBusqueda.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import { GridOptions, GridApi, GridReadyEvent } from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import moment from 'moment';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { fetchReportesSerie } from './fetchReporteSerie';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import { PermisoAccion } from '@/views/base/VariablesPermisos';

import { ParamApi, Clear } from './types/Bitacora.type';

@Component({
  components: {
    MantenedorGrid,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    FormFieldsContainer,
    DatePicker,
  },
})
export default class BitacoraBase extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.Bitacora;
  permiso: any = JSON.parse(localStorage.getItem('user')).permisosUsuario[0]
    .nombrePerfil;

  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };
  accionExportar: PermisoAccion = {
    accionCodigo: 6,
    visible: false,
  };
  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionExportar,
  ];
  readonly loadingService = new LoadingService();

  columnApi: any = null;
  serverSide: any = null;
  gridApi: GridApi = null;
  gridEvent: any = null;
  gridOptions: GridOptions = null;

  activateChange: boolean = false;
  ordesList: any[] = [];
  clientelist: any[] = [];
  modulolist: any[] = [];
  usuariolist: any = [];
  now: string = moment().format('YYYY-MM-DD');

  objParam: ParamApi = {
    start_date: moment().subtract(1, 'month'),
    end_date: moment(),
    usuarioid: '',
    clienteid: '',
    bmodulo: '',
    bdescripcion: '',
  };
  currentObjParam: ParamApi = {};

  constructor() {
    super();

    this.gridOptions = {
      columnDefs: [
        {
          headerName: 'Usuario Acción',
          field: 'username',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 140,
        },
        {
          headerName: 'Usuario RUT ',
          field: 'usuariorut',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 135,
        },
        {
          headerName: 'Cliente',
          field: 'nombre',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 135,
        },
        {
          headerName: 'Fecha',
          field: 'bfecha',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 215,
        },
        {
          headerName: 'Módulo',
          field: 'bmodulo',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 215,
        },
        {
          headerName: 'Tabla',
          field: 'btabla',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 215,
        },
        {
          headerName: 'Acción',
          field: 'baccion',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 215,
        },
        {
          headerName: 'Descripción',
          field: 'bdescripcion',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 215,
        },
        {
          headerName: 'Modulo ID',
          field: 'bmoduloid',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 135,
        },
      ],
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      onGridReady: this.handleGridReady,
    };
  }

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    await this.getEquipos();
    const self = this;

    // OBJ SERVER SIDE
    this.serverSide = {
      async getRows(params: any): Promise<void> {
        params.request.paginationSize = self.gridOptions.cacheBlockSize;
        self.loadingService.showLoading();
        const paramsApi = Object.assign({}, self.objParam, params.request);

        await fetchReportesSerie({ ...paramsApi }, 'conecta_bitacora')
          .then((resp: any) => {
            const {
              CODIGO_RESPUESTA,
              MENSAJE_RESPUESTA,
              LISTA,
              TOTAL_RECORDS,
            } = resp.data;
            const cod: number = Number(CODIGO_RESPUESTA);

            if (cod !== 1 || MENSAJE_RESPUESTA) {
              self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3500 });
              params.successCallback([{}], 0);
              self.gridApi.showNoRowsOverlay();
              return;
            }
            params.successCallback(LISTA, TOTAL_RECORDS);
          })
          .catch((err: Error) => {
            console.error(err.message);
            self.$snotify.error(
              'Ocurrió un error inesperado, por favor reintente un poco más tarde.',
              {
                timeout: 3500,
              }
            );
            throw err;
          })
          .finally(() => self.loadingService.hideLoading());
      },
    };
    this.reloadGrid({});
  }

  async reloadGrid({ clear = false }: Clear): Promise<void> {
    if (clear) this.clear();
    setTimeout(() => {
      this.gridApi.setServerSideDatasource(this.serverSide);
      this.gridApi.setDomLayout('autoHeight');
    }, 0);
  }

  @Watch('objParam.start_date')
  startDateChange() {
    if (this.objParam.start_date > this.objParam.end_date) {
      this.objParam.end_date = this.objParam.start_date;
    }
    this.handleChange();
  }

  @Watch('objParam.end_date')
  endDateChange() {
    if (this.objParam.end_date < this.objParam.start_date) {
      this.objParam.start_date = this.objParam.end_date;
    }
    this.handleChange();
  }

  handleChange(): void {
    if (
      this.objParam.bdescripcion &&
      this.objParam.bdescripcion !== this.currentObjParam.bdescripcion
    ) {
      this.activateChange = false;
      return;
    }
    if (this.objParam.bdescripcion === this.currentObjParam.bdescripcion) {
      this.reloadGrid({});
      return;
    }
    if (this.activateChange || this.objParam.bdescripcion === null) {
      this.objParam.bdescripcion = '';
      this.reloadGrid({});
      return;
    }
  }

  handleSearch(): void {
    this.activateChange =
      this.objParam.bdescripcion &&
      this.objParam.bdescripcion !== this.currentObjParam.bdescripcion
        ? true
        : false;
    this.currentObjParam = { ...this.objParam };
    this.reloadGrid({});
  }

  async getEquipos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie({ '': '' }, 'conecta_bitacora/get_grilla_filters')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.usuariolist = data.data.USUARIO;
          self.clientelist = data.data.CLIENTE;
          self.modulolist = data.data.MODULO;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  clear(): void {
    Object.keys(this.objParam).forEach(
      key =>
        (this.objParam[key as keyof ParamApi] =
          key === 'start_date'
            ? (moment().subtract(1, 'month') as any)
            : key === 'end_date'
            ? moment()
            : '')
    );
    this.activateChange = false;
  }
}
